export default defineNuxtRouteMiddleware(to => {
  const nuxtApp = useNuxtApp()
  nuxtApp.$june.page(to.path, to.query)
})
